import {PaymentStatus} from '../../shared-gen/Payment/Status/PaymentStatus';
import {CreditFun} from '../model/financial/credit.fun';
import {AcceptedPaymentsFun} from './rules/accepted-payments.fun';
import {EligiblePaymentsFun} from './rules/eligible-payments.fun';
import {PaymentPlanFun} from './rules/payment-plan.fun';
import {PaymentMode} from '../../shared-gen/Model/Devices/Config/Payment/PaymentMode';
import {DepositMode} from '../../shared-gen/Payment/Status/DepositMode';

export class PaymentStatusFun {

    static createNew(): PaymentStatus {
        return {
            PaymentMode: PaymentMode.Pay,
            Credit: CreditFun.none(),
            CoinsInTubes: {},
            AcceptedPayments: AcceptedPaymentsFun.none(),
            EligiblePayments: EligiblePaymentsFun.createDefault(),
            PaymentPlan: PaymentPlanFun.createEmpty(),
            ShowCardForRefund: false,
            IsChangeLow: false,
            CoinsDepositMode: DepositMode.Credit,
            Peripherals: {} as any
        }
    }

}
